<template>
  <div class="from">
      <div class="input">
        <form ref="contactForm">
          <h4>線上聯絡表單：</h4>
          <div class="group">
            <input type="text" placeholder="姓名*" name="from_name" v-model="message.name" />
          </div>
          <div class="group">
            <input type="text" placeholder="E-mail" name="from_email" v-model="message.email"/>
          </div>
          <div class="group">
            <input type="text" placeholder="連絡電話*" name="from_phone" v-model="message.phone"/>
          </div>
          <div class="group">
            <textarea placeholder="留言訊息" name="message" v-model="message.message"></textarea>
          </div>
          <input type="hidden" name="timestamp" :value="timestamp" />
          <Button :msg="buttonText"
          :btncolor="btncolor"
          @clickbutton="sendMessage"></Button>
        </form>
      </div>
    </div>
</template>

<script>
import Button from '@/components/only_button.vue';
import emailjs from 'emailjs-com';

export default {
  props: {
    btncolor: {
      type: Array,
      default: () => (['only_form', 'hover-btn']),
    },
  },
  data() {
    return {
      buttonText: '發送訊息',
      message: {
        name: '',
        email: '',
        phone: '',
        message: '',
      },
      timestamp: '',
    };
  },
  mounted() {
    // 初始化 EmailJS
    emailjs.init('dvIGl74P-za-4_hz1');
  },
  components: {
    Button,
  },
  methods: {
    sendMessage() {
      // 檢查必填欄位
      if (!this.message.name || !this.message.phone) {
        // eslint-disable-next-line no-alert
        window.alert('您好，姓名和電話一定要填寫喔~');
        return;
      }

      // 設定時間戳
      this.timestamp = new Date().toLocaleString();
      // 改變按鈕文字
      this.buttonText = '發送中...';

      // EmailJS 設定
      // reference: https://dashboard.emailjs.com/admin/templates/dhnqa4x/content
      // lohi3152@gmail.com
      const serviceID = 'default_service';
      const templateID = 'template_3farms_contact';

      // 使用 sendForm 方法
      emailjs.sendForm(serviceID, templateID, this.$refs.contactForm)
        .then(() => {
          this.buttonText = '發送訊息';
          // eslint-disable-next-line no-alert
          window.alert('傳送成功，請靜待回覆');
          this.message = {
            name: '',
            email: '',
            phone: '',
            message: '',
          };
        })
        .catch((error) => {
          this.buttonText = '發送訊息';
          console.error('EmailJS error:', error);
          // eslint-disable-next-line no-alert
          window.alert('傳送失敗，請稍後再試或直接電話聯絡我們');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.from {
  .input {
    h3 {
      margin-bottom: 20px;
    }
    .group {
      width: 100%;
      text-align: left;
      textarea,
      input {
        width: 100%;
        padding: 10px;
        margin-bottom: 10px;
        outline: none;
        border: none;
        border-radius: 10px;
        border: 1px solid #ddd;
      }
      textarea {
      min-height: 100px;
  }
    }
  }
}
</style>
